// extracted by mini-css-extract-plugin
export var dropdownIcon = "_qc-6";
export var imgContainer = "_qc-3";
export var menuIcon = "_qc-5";
export var pillWrapper = "_qc-2";
export var pillsContainer = "_qc-1";
export var subscriptionCard = "_qc-0";
export var subscriptionLogo = "_qc-4";